<template>
    <table class="table table-sm color">
        <caption class="caption table-caption">{{isAcis ? "Reference" : ""}} Bond Information</caption>
        <tbody>
        <tr>
            <th class="text-left font-weight-normal">Original Balance</th>
            <td class="text-right">{{originalBalance}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Current Balance</th>
            <td class="text-right">{{currentBalance}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Factor</th>
            <td class="text-right">{{factor}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Coupon</th>
            <td class="text-right">{{coupon}}</td>
        </tr>
        <tr v-if="!isAcis">
            <th class="text-left font-weight-normal">Bond Type</th>
            <td class="text-right">{{bondType}}</td>
        </tr>
        <tr v-if="!isAcis">
            <th class="text-left font-weight-normal">Floater Formula</th>
            <td class="text-right">{{floaterFormula}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">CUSIP</th>
            <td class="text-right">{{cusip}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Original Credit Enhancement</th>
            <td class="text-right">{{originalEnhance}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Original Thickness</th>
            <td class="text-right">{{originalThickness}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Current Credit Enhancement</th>
            <td class="text-right">{{currentEnhance}}</td>
        </tr>
        <tr>
            <th class="text-left font-weight-normal">Current Thickness</th>
            <td class="text-right">{{currentThickness}}</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
  props: [
    'originalBalance',
    'currentBalance',
    'factor',
    'coupon',
    'bondType',
    'floaterFormula',
    'isAcis',
    'cusip',
    'originalEnhance',
    'originalThickness',
    'currentEnhance',
    'currentThickness'
  ]
}
</script>
